"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.observable = void 0;
const error_1 = require("./error");
const subject_def_1 = require("./subject-def");
const observable = (options) => ((target, key, descriptor) => {
    /*
        If we are passed a function, it is the class constructor, and we are dealing
        with a static member.

        If passed an object, it is the class' prototype, and we are dealing with
        an instance member.

        https://www.typescriptlang.org/docs/handbook/decorators.html#property-decorators
    */
    if (typeof (target) === 'function') {
        throw new error_1.EcceError(`Static @observable() members are not yet supported: "${target.name}.${String(key)}"`);
    }
    subject_def_1.ClassSubjectDef
        .getOrMakeFor(target.constructor)
        .addProperty(key, descriptor, options);
});
exports.observable = observable;
//# sourceMappingURL=observable-decorator.js.map